import { useQuery } from "@apollo/react-hooks";
import gql from "graphql-tag";

export interface UspDetail {
  value_1: string;
  value_2: string;
}

export interface Usp {
  pill?: string | null;
  title: string;
  subtitle?: string | null;
  description: string[];
  additional_details: UspDetail[];
  web_image: string;
  mobile_image: string;
}

interface UspData {
  usp?: Usp | null;
}

interface UspVars {
  shop_type: string;
}

export const GET_USP = gql`
  query usp($shop_type: String!) {
    usp(shop_type: $shop_type) {
      pill
      title
      subtitle
      description
      additional_details {
        value_1
        value_2
      }
      web_image
      mobile_image
    }
  }
`;

function useUsp(
  shop_type: string,
  skip = false
): {
  loading: boolean;
  error: unknown;
  data: UspData | undefined;
} {
  const { loading, error, data } = useQuery<UspData, UspVars>(GET_USP, {
    variables: { shop_type },
    skip: skip || !shop_type,
    fetchPolicy: "cache-first",
  });

  return { loading, error, data };
}

export { useUsp };
